import { render, staticRenderFns } from "./DevolucionForm.vue?vue&type=template&id=53d2e4ae&scoped=true&"
import script from "./DevolucionForm.vue?vue&type=script&lang=js&"
export * from "./DevolucionForm.vue?vue&type=script&lang=js&"
import style0 from "./DevolucionForm.vue?vue&type=style&index=0&id=53d2e4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d2e4ae",
  null
  
)

export default component.exports